import { isURL } from 'validator';
import { type ZodType, z } from 'zod';

export function parseFirstZodError(fn: z.ZodSchema, value: unknown): string | null {
  const { error } = fn.safeParse(value);
  if (error?.errors == null || error.errors.length === 0) {
    return null;
  }

  let msg = error.errors[0].message;

  // NOTE: this comes from a min(1) rule which is virtually the same as a required
  if (msg.indexOf('must contain at least 1 character') !== -1) {
    msg = 'FIELD_REQUIRED_B';
  }

  return msg;
}

export function defaultNullish<T extends ZodType>(schema: T) {
  return z.preprocess((arg) => (arg == null ? undefined : arg), schema);
}

export function repeatPasswordValidator(base: string) {
  return z.string().refine(function (data) {
    return data === base;
  }, 'FIELD_PASSWORDS_DO_NOT_MATCH');
}

// Converts a string to a WordPress-compatible slug: lowercase, hyphens only.
// NFD decomposition splits accented characters (e.g. é → e + combining accent)
// so the combining marks can be stripped before removing remaining non-ASCII chars.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
export function slugify(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function urlValidator() {
  return z.string().refine(
    function (value) {
      // eslint-disable-next-line camelcase
      return isURL(value, { require_protocol: true });
    },
    {
      message: 'URL_INVALID',
    }
  );
}
